import { useEffect, useState } from "react";
import SubHeader from "../customComponents/SubHeader";
import api from "../../utils/axiosInstance";
import { useDispatch } from "react-redux";
import { showAlert } from "../../redux/alertSlice";

const StorePrices = ({toggleMobileMenu}) => {
  const [formData, setFormData] = useState({
    wmlgrate : '',
    wmlgsrate : '',
  })
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch();

  const handleChange = (name, value)=>{
    setFormData((prev)=>({
      ...prev,
      [name] : value
    }))
  }

  const getStorePrices = async ()=>{
    try {
      setLoading(true)
      const response = await api.get('/store/get-prices')
      if (response.data.success) {
        setLoading(false)
        setFormData(response.data.data)
      } else {
        dispatch(showAlert({type:'warning', message:'Failed to get store prices.'}))
        setLoading(false)
      }
    } catch (error) {
      console.log('Error in getting store prices', error)
      dispatch(showAlert({type:'error', message:'Error in getting store prices.'}))
      setLoading(false)
    }
  }

  const updateStorePrices = async ()=>{
    try {
      setLoading(true)
      const response = await api.post('/store/update-prices', {formData:formData})
      if (response.data.success) {
        dispatch(showAlert({type:'success', message:'Store prices updated successfully.'}))
        getStorePrices();
        setLoading(false)
      } else {
        dispatch(showAlert({type:'warning', message:'Failed to update store prices.'}))
        setLoading(false)
      }
    } catch (error) {
      console.log('Error in updating store prices', error)
      dispatch(showAlert({type:'error', message:'Error in updating store prices.'}))
      setLoading(false)
    }
  }

  const handleSave = () =>{
    if (formData.wmlgrate === '' || formData.wmlgsrate === '') {
      if (formData.wmlgrate === '') {
        dispatch(showAlert({type:'warning', message:'Gold rate is required.'}))
      }
      if (formData.wmlgsrate === '') {
        dispatch(showAlert({type:'warning', message:'Silver rate is required.'}))
      }
    } else {
      updateStorePrices();
    }
  }

  useEffect(()=>{
   getStorePrices();
  },[])

  return (
    <div>
      <SubHeader text={"Store Prices"} toggleMobileMenu={toggleMobileMenu}/>

      <div className="mx-4 md:mx-auto overflow-hidden lg:mb-8 lg:mt-6 lg:max-w-[30rem] bg-white shadow-custom-dark rounded-lg">
        <div className="bg-primary text-white font-mont font-semibold py-2 px-4">
          Update Store Prices
        </div>

        <div className="space-y-6 sm:space-y-8 px-4 sm:px-6">
          <div className="border-b border-gray-900/10 pb-6 sm:pb-8">
            <div className="mt-6 sm:mt-8 grid grid-cols-1 gap-x-6 gap-y-4 sm:gap-y-6 sm:grid-cols-6">
              <div className="sm:col-span-3">
                <label
                  htmlFor="first-name"
                  className="block text-sm/6 text-gray-900 font-mont font-semibold"
                >
                  Gold Rate
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={formData?.wmlgrate}
                    onChange={(e)=>{handleChange('wmlgrate', e.target.value)}}
                    autoComplete="off"
                    className="block w-full font-semibold text-right font-mont rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  className="block font-mont text-sm/6 text-gray-900 font-semibold"
                >
                  Silver Rate
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    value={formData?.wmlgsrate}
                    onChange={(e)=>{handleChange('wmlgsrate', e.target.value)}}
                    autoComplete="off"
                    className="block w-full font-semibold text-right font-mont rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="my-4 px-4 sm:px-0 sm:mr-6 flex flex-col sm:flex-row sm:items-center sm:justify-end space-y-2 sm:space-y-0 sm:space-x-2">
          <button
            onClick={handleSave}
            className="py-2 w-full sm:w-28 border bg-third text-white text-sm font-mont font-semibold rounded-[5px] hover:bg-third/70"
            disabled={loading}
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default StorePrices;
